import { useQuery } from '@tanstack/react-query';
import { client } from '../../api';
import type { NotificationsResponse } from '../../api';
import { MIN_SEARCH_LENGTH } from '../../constants';

/**
 * Hook to search notifications across all status tabs.
 * Used for the search preview dropdown in NotificationsTable.
 *
 * @param searchTerm - The search term to filter notifications by
 * @param enabled - Whether the query should be enabled (default: true when searchTerm has MIN_SEARCH_LENGTH+ characters)
 */
export const useSearchNotifications = (
  searchTerm: string,
  enabled: boolean = searchTerm.length >= MIN_SEARCH_LENGTH,
) => {
  return useQuery<NotificationsResponse>({
    queryKey: ['portalNotifications', 'search', searchTerm],
    queryFn: () =>
      client
        .get('/portal-notifications', {
          params: {
            search: searchTerm,
          },
        })
        .then((res) => res.data),
    enabled,
    // Keep previous data while fetching new results for smoother UX
    placeholderData: (previousData) => (searchTerm.length >= MIN_SEARCH_LENGTH ? previousData : undefined),
  });
};
